import {TriangleDownIcon} from '@primer/octicons-react'
import {ActionList, Button} from '@primer/react'

import type {RepoIssuesBulkUpdate} from '../helpers/repo-issues-bulk-update'

export interface RepoIssuesBulkActionProps {
  disabled: boolean
  nested: boolean
  owner: string
  repo: string
  onUpdate: (update: RepoIssuesBulkUpdate) => void
}

function accessibleAnchorProps(anchorProps: React.HTMLAttributes<HTMLElement>, disabled: boolean) {
  return disabled
    ? {...anchorProps, 'aria-disabled': true, onClick: (event: React.MouseEvent<HTMLElement>) => event.preventDefault()}
    : anchorProps
}

export function RepoIssuesBulkPickerAnchor({
  anchorProps,
  anchorRef,
  disabled,
  nested,
  icon: Icon,
  label,
}: {
  anchorProps: React.HTMLAttributes<HTMLElement>
  anchorRef?: React.RefCallback<HTMLButtonElement | HTMLLIElement>
  disabled: boolean
  nested: boolean
  icon: React.ComponentType
  label: string
}) {
  return nested ? (
    <ActionList.Item {...accessibleAnchorProps(anchorProps, disabled)} role="menuitem" ref={anchorRef}>
      <ActionList.LeadingVisual>
        <Icon />
      </ActionList.LeadingVisual>
      {label}
    </ActionList.Item>
  ) : (
    <Button
      ref={anchorRef}
      leadingVisual={Icon}
      trailingVisual={TriangleDownIcon}
      {...accessibleAnchorProps(anchorProps, disabled)}
    >
      {label}
    </Button>
  )
}
